import React from 'react';
import { translations } from '../Text/translations';

const NetflixSubscribe = ({ currentLang, nickname, mobilenowid, emailnowid }) => {
    const handleSubscribeButtonClick = () => {
      window.location.href = "/enquiry";
    };
  return (
    <>
      <div className="message">
        <h4>{translations[currentLang].netflixSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].netflixSubjectGreeting2}</h4>
        <p>{translations[currentLang].netflixNoBundle}</p>
      </div>
    <div className="cta-buttons">
      <button className="btn primary" onClick={handleSubscribeButtonClick}>
        {translations[currentLang].subscribeNow}
      </button>
      <a href='/netflix' target="_blank" className="link">{translations[currentLang].seeMore}</a>
    </div>
    </>
  );
};

export default NetflixSubscribe;